// extracted by mini-css-extract-plugin
export default {"container":"Compund_container__YQGH3","breadCrumb":"Compund_breadCrumb__Tx2xY"};